import React, { FC } from 'react';

import { ButtonProps } from './button.types';
import * as S from './button.styles';

const Button: FC<ButtonProps> = ({
  text,
  icon,
  isDisabled, // NOTE(omer): we don't want to use the native disabled prop from button element as it causes unwanted behaviours
  variant = 'filled',
  look = 'positive',
  width = 'auto',
  size = 'default',
  onClick,
  ...props
}) => {
  return (
    <S.Button
      {...props}
      $size={size}
      $look={look}
      $variant={variant}
      $width={width}
      type="button"
      onClick={onClick}
      disabled={isDisabled}
    >
      {icon && <S.IconWrapper>{icon}</S.IconWrapper>}
      {text}
    </S.Button>
  );
};

export { Button };
